import React from 'react';
import classNames from 'classnames';
import { useScreenQuery } from 'playup-web-core';
import styled from 'styled-components';
interface Props {
	currentIndex: number;
	slides: {
		imageMobile: string | undefined;
		image: string | undefined;
		title: string;
		content: string;
		footer: JSX.Element;
	}[];
}
const SlideContent = ({ currentIndex, slides }: Props) => {
	const { isSmall } = useScreenQuery();
	return (
		<StyledWrapper $isSmall={isSmall}>
			{slides.map((slide, i) => (
				<div key={slide.title} className={classNames('slide', currentIndex === i && 'selected')}>
					<Image src={isSmall ? slide.imageMobile : slide.image} alt={slide.title} />
					<ContextWrapper>
						<h2>{slide.title}</h2>
						<p>{slide.content}</p>
						{slide.footer}
					</ContextWrapper>
				</div>
			))}
		</StyledWrapper>
	);
};
export default SlideContent;
const ContextWrapper = styled.div({
	height: 'calc(calc(80vh * .9) * .4)',
	alignItems: 'center',
	justifyContent: 'center',
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
});
const Image = styled.img({
	height: 'calc(calc(80vh * .9) * .4)',
	width: '100%',
	objectFit: 'contain',
});
const StyledWrapper = styled.div<{ $isSmall: boolean }>`
	position: relative;
	.slide {
		position: absolute;
		top: 0;
		opacity: 0;
		transition: opacity 500ms;

		&.selected {
			opacity: 1;
			position: static;
		}

		> img {
			background-color: #dedede;
			margin-bottom: ${({ $isSmall }) => ($isSmall ? '18px' : 'unset')};
		}

		h2 {
			font-size: 26px;
			font-weight: 700;
			margin: 0 15px 16px;
			overflow-wrap: break-word;
		}

		p {
			font-size: 18px;
			margin: 0 15px;
			line-height: 1.2;
		}
	}

	.brands {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: ${({ $isSmall }) => ($isSmall ? 20 : 40)}px 0 ${({ $isSmall }) => ($isSmall ? 20 : 40)}px;
		flex-wrap: wrap;

		img {
			height: 30px;
		}

		span {
			margin: -7px 10px 0;
			font-style: italic;
			font-size: 45px;
			line-height: 1;
		}
	}
`;
